let userIP;

const setUserIP = () => {
    fetch('https://jsonip.com', { mode: 'cors' })
        .then((resp) => resp.json())
        .then((resp) => {
           userIP =  resp.ip;
        });
}

if (!userIP) {
    setUserIP();
}

let getUserIP = () => userIP;

export default getUserIP;



// WEBPACK FOOTER //
// ./src/js/lib/getuserip.js